










import { Component, Vue, Watch, Emit } from 'vue-property-decorator'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { mapActions } from 'vuex'
import { cookie } from './http/utils'

@Component({
  components: {
    Header,
    Footer
  }
})

export default class App extends Vue {
  // initial data
  path = ''

  // lifecyle hook
  mounted () {
    this.changeRoute()
    let userId = cookie.getCookie('user_id')
    if (userId) {
      this.$store.dispatch('getUserInfo')
    }

    this.$store.dispatch('getLangList')
  }

  @Watch('$route')
  onRouteChanged () {
    this.changeRoute()
  }

  // computed
  get photoUrl () {
    // let url = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAMAAAAPzWOAAAAA6lBMVEUAAAD8/v/0+v7r9v3j8/ze8fzo8//////r9v3d8f3a7/ra7vrZ7/rZ7/vZ7vvZ7/rb7/vi8vz////n8/vt+f/c7/v////////////X7fn////////////4/P7///////////////////////////8qn+Tw+f3f8ftiuOs0o+W84fba7vqQzfFOr+jk8/u43/Y3peYvoeTE5Pey3PWe0/NEq+dAqef1+v3o9PzP6fis2fRpu+zW7PnU6/mY0fKKyvB/xu94wu1YtOlUsulGq+c8p+aEx+/4+/5ywO3F5fddturG5fdIrOdsveyjcfLZAAAAJHRSTlMA/v769OYsBv5x3dPLtK+cf09BQCpz6t/BuYsMx7X19NWWaVqibds1AAADLklEQVRYw6XXZ3vaMBAH8JMNFLJLZpPu/k8O2BjChjAyGjLafv+v03RFkmXL5unvtZ9DOp10B2Wr7G1vlHwphPRLG9t7FVrXq8NNH8+q4aTbnYRVPPM3D19RcftbHhBPr28b/Ffj9noaA97WPhXzugwE0Ve2fI0CoPya8lXKQPOGM9w0gXIlLxc7Au0WO7TaEDvO3ByUEJxzjvMApQPKVPPQv+BcF314NcqwC3mZ+NHFY+zdy1nvasi6S4ldSvUGwYA1nWiMF+Kbsc1BgDfpMeZ3rLmSMHW/s3I3T4uyi3lDX0YTltEDK425vaMaAn0ddyHSLPVPAtQSZ+vJgb6OEOlWel6kd2DUWAnGuTSRQTzpZ4SSXnU76Bs5Raaxnrg+drT7IoILfTMS2RZ61QVC3aMyjCKI4DDq6MWI8svdR5t1Y7gsWdPG65eFtNgI7zQ37vS/peyjyboFnETHPMc/b90WzDfoEU5m/m6w9btGvIANMdyuWBd4v2rlEBEbPDglPo9wSESbSLzJ93BbmK83NonIj9kk4bZM7N4nqmDKphncHtgwRYX2cM2mHtwSzeAae7SNWzZdwUmy6RbbtIEGm4YCLj02NbBBpSonfcuptYRqifzQ7k5wmHFS6JOcsOXRuZCkiSTRZcv3kSMjlq5QQXQPyBA20oKo7RiWSBUP2TaRKrGmlYAtVDGMxKojTnga2/lQezGPWBVbUmNhpnemziVZbKrsbZ3lXOAP2VMh7LJXF9B299Dvxp4Q9zLsRU+qM1kXUD0FCcPlDIZR84eKk3gKyI9TxzsBWzVKyV/sq+dRN2wjg1yxop5H+6Hm1QjZZi02RKiplqHPSE73Vsuwm9cgQJ6+2bzsNtoaI1/vQm+jVkMfjFHEVGvo1mjRCVDMQo0W1pDTRFGXashJjFsrFCaHatwyBr/hCMW11eBnjKBtrONcjaDaMNzCWiZqGNbG8ibWM0bN/oOwtl2yvMOa3lKKt/8bY/21vKMMpyjslDLVP6CQD3VyODtBASdn5FY/Qo6jOuX7fOQM8ZmK+fIRGT5+oeLOTo8FEsTx6Rmtq/7p5Pi9wDPx/vjkkyMTPwEvAg/tgHo9awAAAABJRU5ErkJggg=='
    let url = ''
    if (this.$store.state.userInfo) {
      url = this.$store.state.userInfo.photo
    }
    return url
  }

  // method
  changeRoute () {
    this.path = this.$route.path
    if (this.$route.name && this.$t('menu.' + this.$route.name)) {
      let pathArr = this.path.split('/')
      let group = pathArr[1]
      let menu = ''
      switch (group) {
        case 'about-us':
          menu = '关于我们'
          break
        case 'product-service':
          menu = '产品与服务'
          break
        case 'learning-commonweal':
          menu = '学术与公益'
          break
        case 'news':
          menu = '新闻'
          break
        default:
          menu = '首页'
          break
      }
      window.zhuge.track('menu', {
        'group': menu,
        'children': this.$t('menu.' + this.$route.name)
      })
    }
    if (this.path === '/') {
      $('.header').css({ 'background-color': 'rgba(42,159,228,0)', 'position': 'fixed' })
      $(window).scroll(() => {
        let offset = 400 // header距顶部距离
        let scrollTop: number = Number($(document).scrollTop())
        let alpha: number = Number((scrollTop / offset).toFixed(2))
        $('.header').css('background-color', 'rgba(42,159,228,' + Math.min(1, alpha) + ')')
      })
    } else {
      $('.header').css({ 'background-color': 'rgba(42,159,228,1)', 'position': 'fixed' })
      $(window).scroll(() => {
        $('.header').css('background-color', 'rgba(42,159,228,1)')
      })
    }
  }
}
